"use strict";

(function () {
  'use strict';

  function AccountHomeCtrl($state) {
    var vm = this;

    this.$onInit = function () {
      $state.go('account.profile');
    };
  }

  AccountHomeCtrl.$inject = ['$state'];
  angular.module('view.account').component('accountHome', {
    bindings: {},
    controller: AccountHomeCtrl,
    templateUrl: 'views/account/components/account-home/account-home.html'
  });
})();